<template>
  <div class="executors-card">
    <div class="section-header" @click="toggleSection">
      <i
        :class="['mdi', isExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right']"
      ></i>
      <span>Виконавці</span>
      <div class="header-actions" @click.stop>
        <span class="users-count">{{ inJobWorkers.length }}</span>
        <!-- <button
          v-if="canManage"
          class="add-user-btn"
          @click="$emit('add-executor')"
          title="Додати виконавця"
        >
          <i class="mdi mdi-plus"></i>
        </button> -->
      </div>
    </div>

    <div v-if="isExpanded" class="users-list">
      <div
        v-for="(worker, index) in inJobWorkers"
        :key="worker.workerId"
        :class="['user-item', { 'is-active': index === 0 }]"
      >
        <!-- <div class="user-avatar bg-soft-success">
          <i class="mdi mdi-account-hard-hat"></i>
        </div> -->

        <div class="user-content">
          <div class="user-name">
            {{ worker.workerName }}
            <span v-if="index === 0" class="primary-badge">Основний</span>
          </div>
          <div class="user-role">
            <!-- <i class="mdi mdi-badge-account"></i> -->
            {{ getWorkerJobTitle(worker.workerId) }}
          </div>
        </div>

        <div class="user-actions">
          <button
            v-if="canManage"
            class="action-btn action-btn-remove"
            @click="$emit('remove-executor', worker)"
            title="Видалити з виконавців"
          >
            <i class="mdi mdi-close"></i>
          </button>
        </div>
      </div>

      <div v-if="inJobWorkers.length === 0" class="empty-state">
        <i class="mdi mdi-account-hard-hat-outline"></i>
        <p>Немає виконавців</p>
      </div>
    </div>
  </div>
</template>

<script>
import { storeS } from "@/store";
import { mutateWorkerJob } from "@/usabilityScripts/globalMutate.js";

export default {
  name: "ExecutorsList",
  props: {
    inJobWorkers: {
      type: Array,
      default: () => [],
    },
    canManage: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["add-executor", "remove-executor"],
  data() {
    return {
      isExpanded: false,
    };
  },
  computed: {
    workers() {
      return storeS.workers || [];
    },
  },
  methods: {
    toggleSection() {
      this.isExpanded = !this.isExpanded;
    },
    getWorkerJobTitle(workerId) {
      const worker = this.workers.find((w) => w.workerId === workerId);
      if (worker && worker.workerJob) {
        return mutateWorkerJob(worker.workerJob);
      }
      return "Посада не вказана";
    },
  },
};
</script>

<style scoped>
.executors-card {
  margin-bottom: 16px;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  cursor: pointer;
  font-weight: 600;
  font-size: 13px;
  color: #495057;
  position: relative;
}

.section-header > i {
  font-size: 16px;
  flex-shrink: 0;
}

.section-header > span {
  flex: 1;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.users-count {
  background: rgb(229 248 240);
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #34c38f;
}

.add-user-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: #34c38f;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.add-user-btn:hover {
  background: #2ba97c;
}

.add-user-btn i {
  font-size: 16px;
  color: white;
}

.users-list {
  margin-top: 8px;
  overflow: visible;
  position: relative;
}

.user-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  margin-bottom: 6px;
  background: #f8f9fa;
  border: 2px solid #f1f3f5;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.user-item:last-child {
  margin-bottom: 0;
}

.user-item:hover {
  border-color: #34c38f;
}

.user-item.is-active {
  border-color: #34c38f;
  background: #f0fdf7;
}

.user-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.user-avatar i {
  font-size: 20px;
  color: #34c38f;
}

.user-content {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 14px;
  font-weight: 600;
  color: #212529;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.primary-badge {
  display: inline-flex;
  padding: 2px 8px;
  background: #34c38f;
  color: white;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.user-role {
  font-size: 11px;
  font-weight: 400;
  color: #9fa5ab;
  display: flex;
  align-items: center;
  gap: 4px;
}

.user-role i {
  font-size: 12px;
}

.user-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.action-btn {
  width: 28px;
  height: 28px;
  border: none;
  background: #f1f3f5;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.action-btn:hover {
  background: #e9ecef;
}

.action-btn i {
  font-size: 16px;
  color: #495057;
}

.action-btn-remove:hover {
  background: #fef5f5;
}

.action-btn-remove:hover i {
  color: #f46a6a;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #adb5bd;
}

.empty-state i {
  font-size: 40px;
  color: #dee2e6;
  margin-bottom: 10px;
  display: block;
}

.empty-state p {
  margin: 0;
  font-size: 13px;
}

@media (max-width: 768px) {
  .section-header {
    font-size: 12px;
    padding: 6px 0;
  }

  .user-item {
    padding: 10px;
  }

  .user-name {
    font-size: 13px;
  }

  .user-role {
    font-size: 10px;
  }

  .primary-badge {
    font-size: 9px;
  }
}
</style>
